import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { SolicitudRelampagoComponent } from 'src/app/modales/solicitud-relampago/solicitud-relampago.component';
import { SolicitudSimuladorComponent } from 'src/app/modales/solicitud-simulador/solicitud-simulador.component';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { UserService } from '../../services/user.service';
declare var $: any;

@Component({
  selector: 'app-simulador',
  templateUrl: './simulador.component.html',
  styleUrls: ['./simulador.component.css'],
  providers: [UserService]
})
export class SimuladorComponent implements OnInit {
  public lineas;
  public codlinea;
  public codplazo;
  public plazos;
  public tasa;
  public resultadosSimulacion;
  public Frecuencia
  public actual = environment.actual
  private salarioM = environment.salarioMinimo
  public identity
  public session_init = false
  simuladorConfig
  public enviarSol = true
  public credirelamp = true;
  public cupo = ''


  public numero: any;
  public fecha: any;
  public capital: any;
  public interes: any;
  public seguro: any;
  public Afiancol: any;
  public total: any;
  public saldo: any;

  public datossimulacion: any = {
    monto: '',
    fechadesembolso: '',
    fechapcuota: '',
    tipocuota: '',
    lineacred: '',
    plazocred: '',
    frecuencia: '',
    tasa: '',
    Entidad: environment.actual
  };


  constructor(
    public _userService: UserService,
    private spinner: NgxSpinnerService,
    public dialog: MatDialog,
  ) {
    let token = this._userService.GetsessionStorage('token')
    if (token == '') {
      this.session_init = false;
    } else {
      this.session_init = true;
      this.identity = JSON.parse(this._userService.GetsessionStorage('identity'));
    }
    this.simuladorConfig = JSON.parse(this._userService.GetsessionStorage('config') || '{}');
    if (Object.keys(this.simuladorConfig).length == 0) {
      this._userService.httpGet('parametrosConfig').subscribe(
        (response: any) => {
          localStorage.setItem('config', JSON.stringify(response.details))
          this.simuladorConfig = response.details
          this.init()
        },
        error => {
          console.log(error)
          this._userService.httpAjax('GET', 'parametrosConfig', '').then(response => {
            localStorage.setItem('config', JSON.stringify(response.details))
            this.simuladorConfig = response.details
            this.init()
          })
        }
      )
    }else{
      this.init()
    }
   }

  async ngOnInit() {
    
  }

  init(){
    this.getLineas();
    this.getFrecuenciaSimulador();
    this.getCupoGeneral();
  }

  getCupoGeneral() {
    if (this.session_init) {
      let date = new Date();
      let day = date.getDate();
      let monthIndex = date.getMonth();
      let year = date.getFullYear();
      let data = {
        codasociado: this.identity.CODASOCIADO,
        fhasta: year + '-' + (monthIndex + 1) + '-' + day,
        codunico: this.identity.CODUNICO
      };
      this._userService.httpPost('calculoCupo', data).subscribe(resp => {
        this.cupo = '(Cupo: ' + '$' + Intl.NumberFormat().format(resp.cupo) + ')'
      })
    }
  }

  getFrecuenciaSimulador() {
    this._userService.httpGet('getFrecuenciaSimulador').subscribe(
      (response: any) => {
        this.Frecuencia = response
      }
    )
  }

  getLineas() {
    this._userService.httpGet('lineasCredito').subscribe(
      response => {
        this.lineas = response;
      },
      error => {
        console.log(<any>error);
      }
    );
  }

  getPlazos($event) {
    this.codlinea = $event.target.value;

    if (this.actual == 'fonasbcol' && this.codlinea != 455) {
      this.credirelamp = true;
    }
    this._userService.httpGet('plazosCredito/' + this.codlinea).subscribe(
      response => {
        const plazomax = response.PLAZMAX;
        this.plazos = Array();
        for (let i = 1; i <= plazomax; i++) {
          this.plazos.push({
            CODPLAZO: i,
            PLAZO: i
          });
        }
      },
      error => {
        console.log(<any>error);
      }
    );
  }
  getTasa($event) {
    const datos = {
      codlin: this.datossimulacion.lineacred,
      plazo: this.datossimulacion.plazocred,
      monto: this.datossimulacion.monto,
    };
    this._userService.httpPost('getTasa', datos).subscribe(
      response => {
        this.datossimulacion.tasa = response.tasa;
        this._userService.httpGet('listarSeguroCredito/' + this.datossimulacion.lineacred).subscribe(
          (responseSeguro: any) => {
            this.datossimulacion.seguro = responseSeguro.details;
            this._userService.httpGet('seguroAfiancol').subscribe(
              (responseAfiancol: any) => {
                this.datossimulacion.afiancol = responseAfiancol.details
              }
            )
          })
      },
      error => {
        alert(error.message);
      }
    );
  }

  simular() {
    this.spinner.show();
    if (this.identity != null) {
      this.datossimulacion.tipoSalario = this.identity.TIPSALARIO;
      this.datossimulacion.codent = this.identity.CODENT;
    } else {
      this.datossimulacion.tipoSalario = 'N';
      this.datossimulacion.codent = '0';
    }
    if (this.simuladorConfig.simulador.actLimitCupo == 'S') {
      if (this.datossimulacion.monto <= this.identity.CUPO) {
        this._userService.httpPost('realizarSimulacion', this.datossimulacion).subscribe(
          response => {
            console.log(response)
            if (response.status != 'error') {
              this.resultadosSimulacion = response.details.plan.cuota;
              console.log("gsgsg", this.resultadosSimulacion);
              this.scrollTOElement('#resultadoSimulacion', 300, 500);
              this.spinner.hide()
              this.enviarSol = false

              this.totalizaSimulacion(this.resultadosSimulacion)

              if (this.actual == 'fonasbcol' && this.codlinea == 455) {
                this.credirelamp = false;
              } else {
                this.credirelamp = true;
              }
            }
          },
          error => {
            this.spinner.hide()
            console.log(<any>error);
            this.enviarSol = true
            this.credirelamp = true;
          }
        );
      } else {
        this.spinner.hide()
        this.enviarSol = true
        this.credirelamp = true;
        Swal.fire({
          icon: 'error',
          text: 'El monto excede el cupo máximo'
        })

      }
    } else {
      this._userService.httpPost('realizarSimulacion', this.datossimulacion).subscribe(
        response => {
          console.log(response)
          if (response.status != 'error') {
            this.resultadosSimulacion = response.details.plan.cuota;
            console.log("gsgsg", this.resultadosSimulacion);
            this.scrollTOElement('#resultadoSimulacion', 300, 500);
            this.spinner.hide()
            this.enviarSol = false

            this.totalizaSimulacion(this.resultadosSimulacion)

            if (this.actual == 'fonasbcol' && this.codlinea == 455) {
              this.credirelamp = false;

            } else {
              this.credirelamp = true;
            }
          } else {
            this.spinner.hide()
            this.enviarSol = true
            this.credirelamp = true;
          }
        },
        error => {
          this.spinner.hide()
          console.log(<any>error);
          this.enviarSol = true
          this.credirelamp = true;
        }
      );
    }
  }

  totalizaSimulacion(datos) {
    this.numero = ""
    this.fecha = "Total"
    let capital = 0;
    let interes = 0;
    let seguro = 0;
    let Afiancol = 0;
    let total = 0;
    for (let i = 0; i < datos.length; i++) {
      capital = capital + parseInt(datos[i].capital[0])
      interes = interes + parseInt(datos[i].interes[0])
      if (this.simuladorConfig.simulador.seguro == 'S') {
        seguro = seguro + parseInt(datos[i].seguro[0])
      }
      if (this.simuladorConfig.simulador.afiancol == 'S') {
        Afiancol = Afiancol + parseInt(datos[i].Afiancol[0])
      }
      total = total + parseInt(datos[i].total[0])
    }

    this.capital = capital
    this.interes = interes
    this.seguro = seguro
    this.Afiancol = Afiancol
    this.total = total
  }

  enviarSolicitud() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.width = '60%';
    const modalRef = this.dialog.open(SolicitudSimuladorComponent, {
      autoFocus: false,
      maxHeight: '80vh' //you can adjust the value as per your view
    });
    modalRef.afterClosed().subscribe(res => {
      if (res.data != false) {
        Object.keys(res.data).forEach(key => {
          this.datossimulacion[key] = res.data[key]
        })
        this.spinner.show()
        this.datossimulacion.nombre = this.identity.NOMBRES;
        this.datossimulacion.apellido = this.identity.APELLIDOS
        this.datossimulacion.nit = this.identity.USUARIO
        this.datossimulacion.codunico = this.identity.CODUNICO
        this._userService.httpPost('solicitudSimulador', this.datossimulacion).subscribe(resp => {
          if (resp.status == 'success') {
            Swal.fire({
              icon: 'success',
              text: 'Su solicitud de crédito se ha enviado exitosamente'
            })
            this.spinner.hide()
          } else {
            Swal.fire({
              icon: 'error',
              text: 'No se pudo enviar la solicitud de crédito'
            })
            this.spinner.hide()
          }
        },
          error => {
            console.log(error)
            this.spinner.hide()
          })
      }
    })
  }

  solicitudCredirelampago() {
    this.spinner.show()

    let data = {}

    let date = new Date();
    let day = date.getDate();
    let monthIndex = date.getMonth();
    let year = date.getFullYear();

    data = {
      codasociado: this.identity.CODASOCIADO,
      codunico: this.identity.CODUNICO,
      nit: this.identity.USUARIO,
      fhasta: year + '-' + (monthIndex + 1) + '-' + day,
      recoge: false,
      pse: false
    }

    this._userService.httpPost('cartera', data).subscribe(
      response => {
        let avanza = true;
        if (response.status == 'success') {
          for (let i = 0; i < response.details.length; i++) {
            if (response.details[i].CODLIN == 455) {
              avanza = false;
            }
          }

          console.log(avanza)

          if (avanza) {
            const dialogConfig = new MatDialogConfig();
            dialogConfig.disableClose = true;
            dialogConfig.width = '60%';


            this._userService.httpPost('datosCred', data).subscribe(
              res => {
                this.spinner.hide()
                //if (this.datossimulacion.monto <= res.cupo && this.datossimulacion.monto <= (this.salarioM * 2)) {
                if (this.datossimulacion.monto <= res.cupo && this.datossimulacion.monto <= parseInt(this.simuladorConfig.simulador.valorRelampago)) {
                  const modalRef = this.dialog.open(SolicitudRelampagoComponent, {
                    autoFocus: false,
                    maxHeight: '80vh', //you can adjust the value as per your view
                    data: { cupo: new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 0 }).format(res.cupo), salario: new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 0 }).format(this.identity.SALARIO), numCuenta: res.cuenta, tipCuenta: res.tipCuenta, telefono: this.identity.TEL1, celular: this.identity.CELULAR }
                  });

                  modalRef.afterClosed().subscribe(resp => {
                    if (resp.data != false) {
                      Object.keys(resp.data).forEach(key => {
                        this.datossimulacion[key] = resp.data[key]
                      })
                      this.spinner.show()
                      this.datossimulacion.nombre = this.identity.NOMBRES;
                      this.datossimulacion.apellido = this.identity.APELLIDOS
                      this.datossimulacion.nit = this.identity.USUARIO
                      this.datossimulacion.codunico = this.identity.CODUNICO
                      this.datossimulacion.codasociado = this.identity.CODASOCIADO

                      this._userService.httpPost('solicitudRelampago', this.datossimulacion).subscribe(response => {
                        if (response.status == 'success') {
                          Swal.fire({
                            icon: 'success',
                            text: 'Su solicitud de crédito se ha enviado exitosamente'
                          })
                          this.spinner.hide()
                        } else {
                          Swal.fire({
                            icon: 'error',
                            text: 'No se pudo enviar la solicitud de crédito'
                          })
                          this.spinner.hide()
                        }
                      },
                        error => {
                          console.log(error)
                          this.spinner.hide()
                        })
                    }
                  })
                } else {
                  Swal.fire({
                    icon: 'error',
                    html: 'El monto a solicitar es superior al cupo disponible o supera el valor de desembolso establecido</br> Cupo: ' + new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 0 }).format(res.cupo) + '</br> Maximo desembolso: ' + new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 0 }).format(this.simuladorConfig.simulador.valorRelampago)
                  })
                }
              },
              error => {
                console.log(error)
              }
            )

          } else {
            Swal.fire({
              icon: 'error',
              text: 'Usted ya cuenta con un credito relampago activo'
            })
          }
        } else {
          console.log(response.details)
        }
        this.spinner.hide()
      },
      error => {
        console.log(<any>error);
        this.spinner.hide()
      }
    );







  }

  scrollTOElement = (element, offsetParam?, speedParam?) => {
    const toElement = $(element);
    const focusElement = $(element);
    const offset = offsetParam * 1 || 200;
    const speed = speedParam * 1 || 500;
    $('html, body').animate({
      scrollTop: toElement.offset().top + offset
    }, speed);
    if (focusElement) {
      $(focusElement).focus();
    }
  }



}
